import {
  BODY_SKINS,
  DIRECTION_DOWN,
  DIRECTION_LEFT,
  DIRECTION_RIGHT,
  DIRECTION_UP,
  ICE_CORNERS,
  INVENTORY,
  PLACEMENT_TYPE_HERO,
} from "../helpers/consts";
import { Placement } from "./Placement";
import Sprite from "../components/object-graphics/Sprite";
import { TILES } from "../helpers/tiles";

const iceFrameMap = {
  DEFAULT: TILES.ICE,
  TOP_LEFT: TILES.ICE_TOP_LEFT,
  TOP_RIGHT: TILES.ICE_TOP_RIGHT,
  BOTTOM_LEFT: TILES.ICE_BOTTOM_LEFT,
  BOTTOM_RIGHT: TILES.ICE_BOTTOM_RIGHT,
};

const iceCornerBlockingMap = {
  [ICE_CORNERS.TOP_RIGHT]: [DIRECTION_UP, DIRECTION_RIGHT],
  [ICE_CORNERS.BOTTOM_RIGHT]: [DIRECTION_DOWN, DIRECTION_RIGHT],
  [ICE_CORNERS.TOP_LEFT]: [DIRECTION_UP, DIRECTION_LEFT],
  [ICE_CORNERS.BOTTOM_LEFT]: [DIRECTION_DOWN, DIRECTION_LEFT],
};

const STAND_ON_ICE_BEFORE_SLIP_FRAMES = 1;

export class IceTilePlacement extends Placement {
  constructor(properties, level) {
    super(properties, level);
    this.corner = properties.corner;
  }

  //TODO - now this is always returning 0
  givesPreAutoMoveFrames(body) {
    if (body.isImmuneToIce) {
      return 0;
    }
    if (
      body.type === PLACEMENT_TYPE_HERO &&
      this.level.inventory.has(INVENTORY.ICE_PICKUP)
    ) {
      return 0;
    }
    // Appear on ice tile for a moment before sliding in direction
    return STAND_ON_ICE_BEFORE_SLIP_FRAMES;
  }

  getNextDirectionForBody(body) {
    if (this.corner) {
      const cornerRedirectMap = {
        TOP_LEFT: {
          [DIRECTION_UP]: DIRECTION_RIGHT,
          [DIRECTION_LEFT]: DIRECTION_DOWN,
        },
        TOP_RIGHT: {
          [DIRECTION_UP]: DIRECTION_LEFT,
          [DIRECTION_RIGHT]: DIRECTION_DOWN,
        },
        BOTTOM_LEFT: {
          [DIRECTION_LEFT]: DIRECTION_UP,
          [DIRECTION_DOWN]: DIRECTION_RIGHT,
        },
        BOTTOM_RIGHT: {
          [DIRECTION_RIGHT]: DIRECTION_UP,
          [DIRECTION_DOWN]: DIRECTION_LEFT,
        },
      };
      return (
        cornerRedirectMap[this.corner][body.movingPixelDirection] ??
        body.movingPixelDirection
      );
    }
    //Default to using the body's as-is direction
    return body.movingPixelDirection;
  }

  isSolid(forBody) {
    const bodyIsBelow = this.y < forBody.y;
    if (bodyIsBelow && this.corner?.includes("BOTTOM")) {
      return true;
    }
    const bodyIsAbove = this.y > forBody.y;
    if (bodyIsAbove && this.corner?.includes("TOP")) {
      return true;
    }
    const bodyIsToLeft = this.x > forBody.x;
    if (bodyIsToLeft && this.corner?.includes("LEFT")) {
      return true;
    }
    const bodyIsToRight = this.x < forBody.x;
    if (bodyIsToRight && this.corner?.includes("RIGHT")) {
      return true;
    }
    return false;
  }

  //This name is still meh. It should mean "You are allowed to move off this space in THIS direction"
  allowsMovingInDirection(direction) {
    if (iceCornerBlockingMap[this.corner]) {
      const isBlocked = iceCornerBlockingMap[this.corner].includes(direction);
      return !isBlocked;
    }
    return true;
  }

  changeHeroSkinOnCollide() {
    if (this.level.inventory.has(INVENTORY.ICE_PICKUP)) {
      return BODY_SKINS.ICE;
    }
    return BODY_SKINS.SCARED;
  }

  renderComponent() {
    //The "DEFAULT" here feels messy
    return <Sprite frameCoord={iceFrameMap[this.corner ?? "DEFAULT"]} />;
  }
}
